// extracted by mini-css-extract-plugin
export default {"search":"vm_search__cKQDd","price":"vm_price__amf3u","headerIcon":"vm_headerIcon__zM+vg","task":"vm_task__sNn4H","userDataTextArea":"vm_userDataTextArea__PY7Dz"};